import { forwardPropsToState } from '../../../utils/react_utils';

const RealizeInputSwitch = window.InputSwitch;

@forwardPropsToState([{prop: 'value'}])
export default class InputSwitch extends RealizeInputSwitch {}
